/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Hotel feature related request structures are defined here
 */
const API = {
  GET_HOTELS: {
    path: '/organizations/:organizationId/hotels?:query',
    method: 'GET',
  },
  GET_CURRENCY_DATA: {
    path: '/organizations/:organizationId/currency?:query',
    method: 'GET',
  },
  POST_HOTEL: {
    path: '/organizations/:organizationId/hotels',
    method: 'POST',
  },
  DELETE_HOTEL: {
    path: '/organizations/:organizationId/hotels/:hotelId',
    method: 'DELETE',
  },
  PATCH_HOTEL: {
    path: '/organizations/:organizationId/hotels/:hotelId',
    method: 'PATCH',
  },
  GET_HOTEL_USER_DATA: {
    path: '/organizations/:organizationId/hotels/:hotelId/users?:query',
    method: 'GET',
  },
};
//
export default API;
//
export const THEMES = [
  { label: 'Historic', name: 'brown', color: '#8B5E3C' },
  { label: 'Beyond Green', name: 'green', color: '#2D6A4F' },
  { label: 'Preferred', name: 'blue', color: '#2e384a' },
  { label: 'aiRO', name: 'light-blue', color: '#009BCD' },
];
